

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const backgroundImages = [
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/0ef1ea5db573fb304ec3bc1c20697d5f.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/7fbe98da1ec0036d8a130e6b4ee25aaa.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/01c4e12326ffa08cdce5027cdcab8b6c.png',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/f06f6ba21bdd78fd3153ba5500e1b55a.jpeg',
    'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/66a0f3be6917eddf5682e860092d64d6.jpeg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Troca a cada 5 segundos

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Images Carousel */}
      <div className="absolute inset-0">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ backgroundImage: `url('${image}')` }}
          />
        ))}
      </div>
      
      <div className="absolute inset-0 bg-[#5C1A24]/70"></div>
      
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center min-h-screen">
        <div className="text-center text-white">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight" style={{ fontFamily: '"Playfair Display", serif' }}>
            Projetos Arquitetônicos e Técnicos que Valorizam a Excelência.
          </h1>
          
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200">
            Transformamos ideias em espaços de alto padrão — combinando técnica, estética e precisão em cada detalhe. Nosso compromisso é criar projetos que reflitam o estilo de vida e o sucesso de quem exige o melhor.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contato"
              className="bg-white text-[#5C1A24] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Fale Conosco
            </Link>
            <Link 
              to="/projetos"
              className="border-2 border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white hover:text-[#5C1A24] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-line mr-2"></i>
              Conheça Nossos Projetos
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

